module.exports = __webpack_public_path__ + "static/media/undraw_no_data.1e5769d5.svg";